import { render, staticRenderFns } from "./ToplistLabels.vue?vue&type=template&id=64c11803&"
import script from "./ToplistLabels.vue?vue&type=script&lang=js&"
export * from "./ToplistLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports